// extracted by mini-css-extract-plugin
export default {"carouselButton":"SwiperCarouselButtons-module--carouselButton--c06e9","left":"SwiperCarouselButtons-module--left--25d1b","right":"SwiperCarouselButtons-module--right--244cf"};